import React, { useState, useEffect, useCallback } from 'react';
import { Progress } from 'antd';
import { apiHolder } from 'api';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { useAppDispatch } from '@web-common/state/createStore';
const storeApi = apiHolder.api.getDataStoreApi();
const ProgressText = ({ leftSec, style }) => {
    return React.createElement("div", { style: style }, leftSec);
};
const RevokeCountDown = ({ id, createTime, attrs, leftSecStyle }) => {
    const [percent, setPercent] = useState(0);
    const [siNo, setSiNo] = useState(-1);
    const [countDownMs, setCountDownMs] = useState(0);
    const dispatch = useAppDispatch();
    const startCountDown = () => {
        let countDownMs = 0;
        const sendRevokeInRes = storeApi.getSync('sendRevokeIn');
        if (!!sendRevokeInRes && sendRevokeInRes.data) {
            countDownMs = Number(sendRevokeInRes.data) * 1000;
            setCountDownMs(countDownMs);
        }
        if (countDownMs < 1)
            return;
        const now = new Date();
        const nowMS = now.getTime();
        let leftMS = createTime + countDownMs - nowMS;
        if (leftMS < 1000)
            return;
        const calcPercent = () => {
            if (leftMS < 0) {
                clearInterval(si);
                setTimeout(() => dispatch(mailActions.doRemoveSendingMail(id)));
                return;
            }
            const curPercent = leftMS / countDownMs;
            setPercent(curPercent * 100);
        };
        calcPercent();
        const si = setInterval(() => {
            leftMS = leftMS - 1000;
            calcPercent();
        }, 1000);
        setSiNo(si);
    };
    const progressFormat = useCallback((percent) => {
        let leftSec = 0;
        if (percent && percent > 0) {
            const leftMs = (countDownMs * percent) / 100;
            leftSec = Math.floor(leftMs / 1000);
        }
        return React.createElement(ProgressText, { leftSec: leftSec, style: leftSecStyle || {} });
    }, [countDownMs]);
    useEffect(() => {
        if (id) {
            clearInterval(siNo);
            startCountDown();
        }
    }, [id]);
    return React.createElement(Progress, Object.assign({ type: "circle" }, attrs, { percent: percent, format: progressFormat }));
};
export default RevokeCountDown;
